var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { THUMBNAIL_SIZE, THUMBNAIL_SIZE_LARGE } from '../../styled';
const [WIDTH, HEIGHT] = THUMBNAIL_SIZE;
const [WIDTH_LARGE, HEIGHT_LARGE] = THUMBNAIL_SIZE_LARGE;
/**
 * Thumbnail wrapper to provide 1,65 aspect ratio
 * for its children. Pinned and row mode uses exact size 154x250.
 */
const Inner = styled.div `
  box-sizing: border-box;

  &:not(:last-child) {
    margin-right: var(--fw-thumbnail-gap, 10px);
  }
  overflow: hidden;
  padding-top: 0;
  position: relative;

  ${(props) => `
    flex: 0 0 var(--fw-thumbnail-width, ${props.width}px);
    height: var(--fw-thumbnail-height, ${props.height}px);
    width: var(--fw-thumbnail-width, ${props.width}px);
  `}

  ${(props) => props.displayMode === 'grid' &&
    `
    flex: 0;
    height: 0;
    margin-left: 0;
    margin-right: 0;
    padding-top: 165%;
    width: 100%;
  `}
`;
const Outer = styled.div `
  border-radius: var(--border-radius);
  box-sizing: border-box;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  transform: translateZ(0);
  width: 100%;
`;
const ThumbnailWrapper = (_a) => {
    var { mode, isLarge, children } = _a, rest = __rest(_a, ["mode", "isLarge", "children"]);
    // Large carousel experiment
    const width = isLarge ? WIDTH_LARGE : WIDTH;
    const height = isLarge ? HEIGHT_LARGE : HEIGHT;
    return (<Inner displayMode={mode} height={height} width={width} {...rest}>
      <Outer>{children}</Outer>
    </Inner>);
};
export default ThumbnailWrapper;
